import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    FooterColumnMobile,
    FooterNavigation,
    MainContentWrapper,
    MainFooter,
    MainWrapper,
} from 'src/domains/layouts/webview/modules/layoutSkeleton/footer/content/FooterContent.style';
import { PaymentMethod } from 'src/domains/layouts/webview/modules/layoutSkeleton/footer/paymentMethods/PaymentMethods';
import { ContactUs } from 'src/domains/layouts/webview/modules/layoutSkeleton/footer/contactUs/ContactUs';
import { MobileFooter } from 'src/domains/layouts/webview/modules/layoutSkeleton/footer/mobileFooter/MobileFooter';
import { GetTheApp } from 'src/domains/layouts/webview/modules/layoutSkeleton/footer/getTheApp/GetTheApp';
import { AboutPages } from 'src/domains/layouts/webview/modules/layoutSkeleton/footer/aboutPages/AboutPages';
import { FooterCopyright } from 'src/domains/layouts/webview/modules/layoutSkeleton/footer/copyright/FooterCopyright';
import { UniverseComponent } from 'src/domains/common/universes';
import { ResponsibleGamblingDefault } from 'src/domains/layouts/webview/modules/layoutSkeleton/footer/responsibleGambling/ResponsibleGamblingDefault';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export const FooterContent = observer('FooterContent', () => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const isClosing =
        configState.closureModeWithLogin || configState.closureMode || configState.midnightMigrationScreen;
    return (
        <>
            <MainFooter
                variant={configState.componentVariants.sportsbookVariant}
                layoutVariant={configState.componentVariants.layoutVariant}
            >
                <MainWrapper variant={configState.componentVariants.sportsbookVariant}>
                    <MainContentWrapper>
                        <FooterColumnMobile>
                            <FooterNavigation>
                                <AboutPages />
                            </FooterNavigation>

                            <FooterNavigation>
                                <ContactUs />

                                <GetTheApp />
                            </FooterNavigation>
                        </FooterColumnMobile>

                        <UniverseComponent>
                            {(universeComponent): React.ReactElement => (
                                <FooterColumnMobile>
                                    {universeComponent.paymentLogotypes() === null ? null : (
                                        <FooterNavigation>
                                            <PaymentMethod />
                                        </FooterNavigation>
                                    )}
                                    <FooterNavigation>
                                        <ResponsibleGamblingDefault />
                                    </FooterNavigation>
                                </FooterColumnMobile>
                            )}
                        </UniverseComponent>
                    </MainContentWrapper>

                    <FooterCopyright />
                </MainWrapper>
            </MainFooter>

            {isClosing ? null : <MobileFooter />}
        </>
    );
});
